import React from 'react';
import HeroSection from '../components/HeroSection';
import ServicesPreview from '../components/ServicesPreview';
import WhyChooseUs from '../components/WhyChooseUs';
import TechStack from '../components/TechStack';
import Testimonials from '../components/Testimonials';
import CTABanner from '../components/CTABanner';

const Home = () => (
  <main>
    <HeroSection />
    <ServicesPreview />
    <WhyChooseUs />
    <TechStack />
    <Testimonials />
    <CTABanner />
  </main>
);

export default Home;
